"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsProd = exports.useIsAdmin = void 0;
const config_1 = require("@app/const/config");
const is_defined_1 = require("../is-defined");
const useIsAdmin = () => (0, is_defined_1.isValue)(document.querySelector('.ds-adminpanel')) || config_1.env === 'dev';
exports.useIsAdmin = useIsAdmin;
const useIsProd = () => window.location.hostname === 'https://app.dayswaps.com/';
exports.useIsProd = useIsProd;
